import format from "comma-number";
import Link from "next/link";
import useSWR from "swr";
import { apiUrl } from "~/config";
import fetcher from "~/lib/fetcher";

/**
 * A post in a list, with its view count. Fetches the count itself unless `views` is given, or
 * `fetchViews` is false because the list fetches every count at once. The blog's counts come from
 * `apiUrl`; the inner circle's stay on the site, behind its session.
 */
const BlogPost = ({ title, summary, slug, blogUrl = "blog", views = null, session = null, fetchViews = true }) => {
  const base = blogUrl === "blog" ? apiUrl : "";
  const { data } = useSWR(
    views == null && fetchViews ? [slug ? `${base}/api/${blogUrl}/${blogUrl}/${slug}` : null, session] : null,
    fetcher
  );
  views = data?.total ?? views;

  return (
    <div className="mb-8 w-full">
      <div className="flex flex-col md:flex-row justify-between">
        <h4 className="underline text-lg md:text-xl font-medium mb-2 w-full text-gray-900 dark:text-gray-100">
          <Link href={`/${blogUrl}/${slug}`} className="no-underline w-full">
            {title}
          </Link>
        </h4>
        <p className="text-gray-500 text-left md:text-right w-32 mb-4 md:mb-0">
          {`${views != null ? format(views) : "–––"} views`}
        </p>
      </div>
      <p className="text-gray-600 dark:text-gray-400">{summary}</p>
    </div>
  );
};

export default BlogPost;
